import { Vue } from 'vue-class-component';
import { GenericObject, Selectable } from '@/includes/definitions/index.d';
import { WordText } from '@/includes/definitions/word.d';

export default class SearchMixin extends Vue {
  query: string;
  words: Selectable<Partial<WordText>>[] = [];

  get displayedWords() {
    return this.query
      ? this.words.filter(
        (w) => (w.text.toLowerCase()
          .includes(this.query.toLowerCase())
          || w.meaning.toLowerCase()
            .includes(this.query.toLowerCase())),
      )
      : this.words;
  }

  get wordMap() {
    return new Map(Object
      .entries(this.words.reduce((map: GenericObject, w: Selectable<WordText>) => {
        // eslint-disable-next-line no-param-reassign
        map[w.text + w.meaning] = w;
        return map;
      }, {})));
  }
}
